import { useImageKit } from '@context/ImageKitContext'
import { useState } from 'react'

export const useImageUploader = onImageUpload => {
  const [uploading, setUploading] = useState(false)
  const [error, setError] = useState(null)
  
  const { uploadImage, deleteImage } = useImageKit()

  const handleFileChange = async e => {
    const file = e.target.files[0]
    if (!file) return

    setUploading(true)
    setError(null)

    try {
      const { url, filePath, fileId } = await uploadImage(file, file.name)
      await onImageUpload( {url,filePath, fileId})
      alert('Imágen subida con éxito')
    } catch (err) {
      setError('Error al subir la imagen')
      console.error('Upload error:', err)
    } finally {
      setUploading(false)
    }
  }

  const handleDeleteImage = async fileId => {
    try {
      await deleteImage(fileId)
      alert('Imagen eliminada correctamente')
    } catch (error) {
      console.error('Error al eliminar la imagen:', error)
      alert('No se pudo eliminar la imagen.')
    }
  }

  return { uploading, error, handleFileChange, handleDeleteImage }
}
